// tank products component
const TankProducts = () => import("Modules/tank_products/views/TankProducts");

export default {
    children: [
        {
            path: "tank_products",
            name: "tank_products",
            component: TankProducts,
            meta: {
                requiresAuth: true,
                title: "lang.tank_products",
                restrict_by_login_type: [
                    "employee",
                    "customer_support",
                    "administrator",
                    "developer",
                    "csr",
                    "producer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "d_acct_mgr",
                    "customer_readonly",
                    "customer",
                    "distributor",
                ],
                restrict_by_permission: ["products.read"],
            },
        },
    ],
};
